import { render, staticRenderFns } from "./Setup_ClientsGroupEdit.vue?vue&type=template&id=c1a47d68&"
import script from "./Setup_ClientsGroupEdit.vue?vue&type=script&lang=js&"
export * from "./Setup_ClientsGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports